<template>
  <div class="flex flex-row min-h-screen" :class="{ 'qod-layout': isQuestionOfDay }">
    <div id="drawer" :class="{ 'qod-drawer-open': qodMenuOpen }">
      <div id="menu">
        <IconBase
          name="logo"
          class="mb-4 mt-4 mx-auto"
          width="32"
          height="32"
        />
        <template
          v-for="(menuPosition, i) in menuPositions"
          :key="`menuPosition-${i}`"
        >
          <MenuPosition :data="menuPosition" />
        </template>
        <Avatar
          v-if="user"
          @click="toggle"
          shape="circle"
          :icon="!user.avatar_file ? 'pi pi-user' : null"
          aria-haspopup="true"
          aria-controls="overlay_menu"
          :image="user.avatar_file"
          class="cursor-pointer user-avatar mt-auto mb-3 mt-5 mx-auto"
        />
        <Menu :model="userMenu" ref="usermenu" :popup="true" />
      </div>
    </div>
    <div class="main-content">
      <div id="navbar">
        <Button v-if="isQuestionOfDay" class="qod-mobile-menu p-button-sm p-button-outlined" label="Menu" aria-controls="drawer" :aria-expanded="qodMenuOpen" @click="qodMenuOpen = !qodMenuOpen" />
        <Breadcrumbs :data="breadcrumbs" />
        <div>
          <Transition name="slide-up">
            <div
              v-if="route.meta.buttons && route.meta.buttons.length"
              id="layout-buttons"
            >
              <router-link
                v-for="(item, i) in route.meta.buttons"
                :key="`child-route-${i}`"
                :to="{ name: item.to, params: item.params, query: item.query }"
              >
                <Button
                  :class="[
                    'p-button-md',
                    {
                      'p-button-secondary': item.params,
                    },
                  ]"
                >
                  <IconBase :name="item.icon" class="mr-2" />
                  {{ $t(item.title) }}
                </Button>
              </router-link>
              <div id="extra-buttons"></div>
            </div>
          </Transition>
        </div>
      </div>
      <div class="px-5 py-5 main-layout-wrapper">
        <RouterView v-slot="{ Component }">
          <Transition name="slide-up" :duration="100" mode="out-in">
            <component :is="Component" />
          </Transition>
        </RouterView>
      </div>
    </div>
  </div>
</template>

<script setup>
import Breadcrumbs from "@/components/global/Breadcrumbs.vue";
import MenuPosition from "@/components/global/MenuPosition.vue";
import Avatar from "primevue/avatar";
import IconBase from "@/components/global/IconBase.vue";
import Button from "primevue/button";
import Menu from "primevue/menu";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { useI18n } from "vue-i18n";
const route = useRoute();
const isQuestionOfDay = computed(() => String(route.name || '').startsWith('QuestionOfDay'));
const qodMenuOpen = ref(false);
watch(() => route.fullPath, () => { qodMenuOpen.value = false; });
const { t } = useI18n({});
const menuPositions = (() => {
  const items = useRouter()
    .getRoutes()
    .filter((item) => item.name.includes("View") && !item.aliasOf);
  const accredibleIndex = items.findIndex(
    (item) => item.name === "AccredibleView"
  );
  const generateIndex = items.findIndex(
    (item) => item.name === "GenerateCertificateView"
  );
  if (accredibleIndex !== -1 && generateIndex !== -1) {
    const [generateRoute] = items.splice(generateIndex, 1);
    const targetIndex = items.findIndex((item) => item.name === "AccredibleView");
    items.splice(targetIndex + 1, 0, generateRoute);
  }
  return items;
})();

const { logout, getUser } = useAuthStore();

const breadcrumbs = computed(() => route.meta.breadcrumbs);
const user = getUser;

const usermenu = ref();

const toggle = (event) => {
  usermenu.value.toggle(event);
};

const userMenu = ref([
  {
    label: t("base.auth.logout"),
    icon: "pi pi-power-off",
    command: () => logout(),
  },
]);
</script>

<style lang="scss" scoped>
.user-avatar {
  background: var(--gray-100);
  &:hover {
    background: var(--gray-200);
  }
}
#layout-buttons {
  display: flex;
  grid-gap: 24px;
}

#drawer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--base-white);
  border-right: 2px solid var(--gray-200);
  #menu {
    position: sticky;
    min-height: 100vh;
    width: 200px;
    top: 0;
    display: flex;
    flex-direction: column;
    // align-items: center;
    background-color: var(--base-white);
    > div {
      // display: flex;
      // justify-content: center;
    }
  }
}
#navbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--base-white);
  padding: 0 32px;
  border-bottom: 2px solid var(--gray-200);
  min-height: 70px;
}
:deep(.p-avatar) {
  width: 36px;
  height: 36px;
}

.main-content {
  width: calc(100vw - 76px);
  overflow: auto;
}

.qod-mobile-menu { display: none; }
.qod-layout .main-content { flex: 1; width: 0; min-width: 0; }
@media (max-width: 700px) {
  .qod-layout {
    .qod-mobile-menu { display: inline-flex; flex-shrink: 0; }
    #navbar { padding: 0 16px; gap: 12px; }
    .main-layout-wrapper { padding: 20px 16px !important; }
    #drawer {
      display: none;
      &.qod-drawer-open {
        display: flex; position: fixed; z-index: 100; top: 70px; bottom: 0; left: 0;
        width: 220px; overflow-y: auto; box-shadow: 4px 8px 20px #0002;
        #menu { width: 100%; min-height: 0; position: static; }
      }
    }
  }
}
</style>
